import React from 'react';
import StudentList from './components/StudentList.jsx';
import Footer from './components/Footer.jsx';

const App = () => {
  return (
    <div>
      <StudentList />
      <Footer />
    </div>
  );
};

export default App;
